import React from "react";
import styled from "styled-components";
import Button from "../../../components/Button";
import {
  AboutUI,
  Title,
  Subtitle,
  AboutInfoContainer,
  AboutInfo,
  Paragraph,
  Img,
} from "../../home/sections/About";
import { Link } from "react-router-dom";

const AboutPage = styled(AboutUI)`
  margin-top: 90px;
  padding: 70px;
  overflow-x: hidden;

  @media (max-width: 992px) {
    padding: 70px 10px;
  }
`;

const ReversedAboutInfoContainer = styled(AboutInfoContainer)`
  flex-direction: row-reverse;
  max-width: 1400px;
  margin: 0 auto;
  @media (max-width: 1350px) {
    gap: 80px;
  }
  @media (max-width: 992px) {
    flex-direction: column;
    gap: 50px;
  }
`;

const AboutIMG = styled(Img)`
  border-radius: 10px;
  box-shadow: rgba(17, 17, 26, 0.05) 0px 1px 0px,
    rgba(17, 17, 26, 0.1) 0px 0px 8px;
`;

const BtnUI = styled.button`
  background-color: var(--red);
  font-size: 16px;
  border: 1px solid var(--red);
  border-radius: 20px;
  font-family: var(--roboto);
  width: 180px;
  height: 40px;
  cursor: pointer;
  transition: all 0.2s ease-out;
  font-weight: 500;
  text-decoration: none;
  color: var(--white);
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (min-width: 1000px) {
    &:hover {
      transition: all 0.2s ease-in;
      background-color: var(--white);
      color: var(--red);
    }
  }
`;

const Btn = ({ text, path }) => {
  return (
    <>
      <Link to={path || "./"}>
        <BtnUI to={path || "./"}> {text} </BtnUI>
      </Link>
    </>
  );
};

const AboutSection = () => {
  return (
    <>
      <AboutPage>
        <Title>
          SOMOS <span>REAL CARS</span>
        </Title>
        <AboutInfoContainer data-aos="fade-right">
          <AboutInfo>
            <Subtitle>Sobre Nosotros</Subtitle>
            <Paragraph>
              Somos una compañía líder en alquiler de vehículos. Nuestra
              experiencia nos permite seguir apostando y ampliando nuestra flota
              continuamente, respondiendo a las necesidades de movilidad para
              todo tipo de pasajeros.
            </Paragraph>
            <Button inverted text="Ver Flota" path="/flota" />
          </AboutInfo>
          <AboutIMG src="/images/About/about1.jpg" />
        </AboutInfoContainer>
        <ReversedAboutInfoContainer data-aos="fade-left">
          <AboutInfo>
            <Subtitle>Nuestro Compromiso</Subtitle>
            <Paragraph>
              Nuestro compromiso es brindar calidad, comodidad, confort y
              seguridad a todos nuestros clientes. Ofrecemos un servicio que
              incluye kilometraje ilimitado y cobertura para que disfrute del
              viaje.
            </Paragraph>
          </AboutInfo>
          <AboutIMG src="/images/About/about2.jpg" />
        </ReversedAboutInfoContainer>
        <AboutInfoContainer data-aos="fade-right">
          <AboutInfo>
            <Subtitle>Nuestro Objetivo</Subtitle>
            <Paragraph>
              Buscamos garantizar una excelente relación precio-calidad,
              acercando la posibilidad, a mayor público, en la realización de
              sus viajes con total autonomía.
            </Paragraph>
          </AboutInfo>
          <AboutIMG src="/images/About/about3.jpg" />
        </AboutInfoContainer>
        <ReversedAboutInfoContainer data-aos="fade-left">
          <AboutInfo>
            <Subtitle>Viaja Con Nosotros</Subtitle>
            <Paragraph>
              Nos ubicamos en la Ciudad autónoma de Buenos Aires, Argentina y
              contamos con atención permanente.
              <span>
                ¡Sumergite hoy en la experiencia de manejar el vehículo que
                estabas buscando !{" "}
              </span>
            </Paragraph>
            <Btn text="Como Contratarnos" path="/como-contratarnos"></Btn>
          </AboutInfo>
          <AboutIMG src="/images/About/about4.jpg" />
        </ReversedAboutInfoContainer>
      </AboutPage>
    </>
  );
};

export default AboutSection;
